export default __webpack_public_path__ + "static/media/sticker.af1379ad.jpg";